
import { Component, Vue } from "vue-property-decorator";

import Pagination from "@/components/Pagination/index.vue";
import { OperationPointsService, OperationPointsDto } from "@/api/service-proxies";
import PagedListBase, {
    PagedRequestDto
} from "@/lib/view-base/paged-list-base";
import SchoolSelector from './components/school-selector.vue'
import moment from "moment";
import { Row } from "element-ui";
class pointPagedRequest extends PagedRequestDto {

    tenantId !: number
    name: string;
    startTime!: moment.Moment;
    endTime!: moment.Moment;
}

@Component({
    name: "totalPoint",
    components: {
        Pagination, SchoolSelector
    }
})
export default class totalPoint extends PagedListBase<
    pointPagedRequest,
    OperationPointsDto
> {
    pointsSum = 0;
    request = new pointPagedRequest();
    OperationPoints=new OperationPointsService()
    date = []
    pickerOptions = {
        shortcuts: [{
            text: '最近一周',
            onClick(picker) {
                const end = new Date();
                const start = new Date();
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                picker.$emit('pick', [start, end]);
            }
        }, {
            text: '最近一个月',
            onClick(picker) {
                const end = new Date();
                const start = new Date();
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                picker.$emit('pick', [start, end]);
            }
        }, {
            text: '最近三个月',
            onClick(picker) {
                const end = new Date();
                const start = new Date();
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                picker.$emit('pick', [start, end]);
            }
        }]
    }
    created() {
        this.refresh();
    }

    getpage(finishCallback: Function): void {
        this.OperationPoints
          .getOperationPoints(
            this.request.tenantId,
            this.request.name,
            this.request.startTime,
            this.request.endTime,
            this.request.skipCount,
            this.request.maxResultCount
          )
          .then(result => {

            this.list = result.items;
            this.pointsSum = result.pointSum
            this.showPaging(result);
          })
          .finally(() => {
            finishCallback();
          });
    }
    dateChange(e) {
        if (e) {
            this.request.startTime = moment(this.date[0]);
            this.request.endTime = moment(this.date[1]);
        } else {
            this.request.startTime = null;
            this.request.endTime = null;
        }
    }
    schoolChange(event: any) {
        this.request.tenantId = event.tenantId
    }

    handleUpdate(msg) {
        // this.$router.push({ path: '/editorPointRuls', query: { id: c }})
        this.$router.push({
            name: "/pointDetails",
            query: { id: msg.userId },
        });
        // this.$router.push({ path: `/Coupon/update/${Coupon.id}` });
    }




}
